import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import HomePage from "./HomePage";
import PaceWorksForm from "./PaceWorksForm";
import TrainingPlanOutput from "./TrainingPlanOutput";
import Header from "./Header";
import Footer from "./Footer";
import NotFoundPage from "./pages/NotFoundPage";
import CalculatorPage from "./pages/CalculatorPage";
import AboutPage from "./pages/AboutPage";
import LegalPage from "./pages/LegalPage";
import PaceNotes from "./pages/pace-notes";
import Feedback from "./Feedback";
import ContactPage from "./pages/ContactPage";
import FaqPage from "./pages/FaqPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import ScrollToTop from "./components/ScrollToTop";

import "./App.css";

export default function App() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh", background: "#111111" }}>
        <ScrollToTop />
        <Header />
        <div style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/build" element={<PaceWorksForm />} />
            <Route
              path="/plan"
              element={
                <div className="pw-plan-route">
                  <TrainingPlanOutput />
                </div>
              }
            />
            <Route path="/calculator" element={<CalculatorPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/legal" element={<LegalPage />} />
            <Route path="/pace-notes" element={<PaceNotes />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}
